/**
 * @fileoverview Modal component for previewing JSON configuration data with copy functionality.
 */

/**
 * Modal component that displays JSON configuration data in a formatted view
 * @component
 * @param {Object} props - Component props
 * @param {boolean} props.visible - Controls the visibility of the modal
 * @param {Function} props.onCancel - Callback function when modal is closed
 * @param {Object} props.config - JSON configuration object to display
 * @param {Function} props.onCopy - Callback function when copy button is clicked
 * @returns {React.ReactElement} A modal component with JSON preview
 */
import React from "react";
import { Modal, Button } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const ConfigPreviewModal = ({ visible, onCancel, config, onCopy }) => (
  <Modal
    title="Configuration Preview"
    open={visible}
    onCancel={onCancel}
    footer={[
      <Button key="copy" icon={<CopyOutlined />} onClick={onCopy}>
        Copy to Clipboard
      </Button>,
      <Button key="close" onClick={onCancel}>
        Close
      </Button>,
    ]}
    width={800}
  >
    <pre
      style={{
        backgroundColor: "#f5f5f5",
        padding: "15px",
        borderRadius: "4px",
        maxHeight: "500px",
        overflow: "auto",
        direction: "ltr",
        textAlign: "left",
        fontFamily: "monospace",
      }}
    >
      {config && JSON.stringify(config, null, 2)}
    </pre>
  </Modal>
);

export default ConfigPreviewModal;
